import { render, staticRenderFns } from "./ConfigTableItemSkeletonMobile.vue?vue&type=template&id=3b172557&scoped=true"
import script from "./ConfigTableItemSkeletonMobile.vue?vue&type=script&lang=js"
export * from "./ConfigTableItemSkeletonMobile.vue?vue&type=script&lang=js"
import style0 from "./ConfigTableItemSkeletonMobile.vue?vue&type=style&index=0&id=3b172557&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b172557",
  null
  
)

export default component.exports